import React, { useState } from "react";
import styles from "./InfoPopover.module.scss";
import { COLORS_INFO as COLORS } from "../constants";
import PopoverChart from "../PopoverChart/PopoverChart";
import { WORKS_TAB_ID } from "../../../constants";

const InfoPopover = ({ indicators, type }) => {
  const [hover, setHover] = useState(false);
  const [Y, setY] = useState(0);

  let finalCount;
  let finalCompleted;
  let finalAccepted;
  let finalToPay;
  let finalMeasure;

  if (type === WORKS_TAB_ID) {
    const { tickets_count, to_payed_count, count_accepted, count, measure} = indicators;
    finalCount = Number(count) || 0;
    finalCompleted = Number(tickets_count) || 0;
    finalAccepted = Number(count_accepted) || 0;
    finalToPay = Number(to_payed_count) || 0;
    finalMeasure = measure || ' ';
  } else {
    const {
      product_using_count,
      confirm_using_closed,
      confirm_sum_using_count,
      count,
      measure,
    } = indicators;
    finalCount = Number(count) || 0;
    finalCompleted = Number(product_using_count) || 0;
    finalAccepted = Number(confirm_sum_using_count) || 0;
    finalToPay = Number(confirm_using_closed) || 0;
    finalMeasure = measure || ' ';
  }

  const onHover = (e) => {
    setHover(true);
    setY(e?.nativeEvent?.y || 0);
  };

  const dataAll = {
    name: "Количество",
    value: finalCount,
  };

  const data = [
    {
      name: "Выполнено",
      value: finalCompleted,
      key: "completed",
      percent: dataAll.value && Math.round((finalCompleted * 100) / dataAll.value),
    },
    {
      name: "Принято",
      value: finalAccepted,
      key: "accepted",
      percent: dataAll.value && Math.round((finalAccepted * 100) / dataAll.value),
    },
    {
      name: "К оплате",
      value: finalToPay,
      key: "to_pay",
      percent: dataAll.value && Math.round((finalToPay * 100) / dataAll.value),
    },
  ];

  const popupStyles =
    window.innerHeight - (Y + 336) < 0
      ? { transform: "translateY(-105%)", paddingBottom: "1rem" }
      : { paddingTop: ".5rem" };

  return (
    <div className={styles.info} onMouseEnter={onHover} onMouseLeave={() => setHover(false)}>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g id="Сгруппировать_7264" data-name="Сгруппировать 7264" transform="translate(-189.063)">
          <circle
            id="Эллипс_48574"
            data-name="Эллипс 48574"
            cx="10"
            cy="10"
            r="10"
            transform="translate(189.063)"
            fill="#FFFFFF"
          />
          <path
            id="Контур_5801"
            data-name="Контур 5801"
            d="M2.544,0H1.456V-7.488H2.544Zm.224-10.368a.709.709,0,0,1-.24.552A.773.773,0,0,1,2-9.6a.773.773,0,0,1-.528-.216.709.709,0,0,1-.24-.552.709.709,0,0,1,.24-.552A.773.773,0,0,1,2-11.136a.773.773,0,0,1,.528.216A.709.709,0,0,1,2.768-10.368Z"
            transform="translate(197.063 15)"
            fill="#000000"
          />
        </g>
      </svg>
      {hover && (
        <div
          className={styles.infoPopover}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          style={popupStyles}
        >
          <div className={styles.infoPopoverContainer}>
            <span className={styles.infoPopoverTitle}>Прогресс выполнения</span>
            <div className={styles.infoPopoverHeading}>
              <span>Количество:</span>
              <span>{`${finalCount} (${finalMeasure})`}</span>
            </div>
            <PopoverChart chartData={data} dataAll={dataAll} colors={COLORS} />
            <div className={styles.legend}>
              {data.map((x, index) => (
                <React.Fragment key={index}>
                  <div className={styles.infoPopoverItemMarker}>
                    <div className={styles.square} style={{ backgroundColor: COLORS[x.key] }} />
                    <span>{x.name}:</span>
                  </div>
                  <span>{`${x.value > 0 && x.percent < 1 ? '<1' : x.percent}%`}</span>
                  <span>{`${x.value} (${finalMeasure})`}</span>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InfoPopover;
